import InfiniteScroll from "react-infinite-scroll-component";
import Masonry from "react-responsive-masonry";

import { GiphyGridSkeleton } from "./GiphyGridSkeleton";
import type { GiphyItem } from "./types";

interface GiphyGridProps {
  fetchNextPage: () => void;
  gifs: GiphyItem[];
  hasNextPage: boolean;
  isDisabled: boolean;
  onSelect: (gif: GiphyItem) => void;
}

export const GiphyGrid = ({
  gifs,
  hasNextPage,
  fetchNextPage,
  isDisabled,
  onSelect,
}: GiphyGridProps) => (
  <InfiniteScroll
    dataLength={gifs.length}
    next={fetchNextPage}
    hasMore={hasNextPage}
    scrollThreshold={0.6}
    height={360}
    loader={
      <div className="py-2">
        <GiphyGridSkeleton count={3} />
      </div>
    }
  >
    <Masonry columnsCount={3} gutter="8px">
      {gifs.map(gif => (
        <button
          type="button"
          key={gif.id}
          onClick={() => onSelect(gif)}
          aria-label={gif.title}
          disabled={isDisabled}
        >
          <img
            loading="lazy"
            alt=""
            className="rounded-sm"
            width={180}
            src={gif.images.preview_gif.url}
          />
        </button>
      ))}
    </Masonry>
  </InfiniteScroll>
);
